/**
 * Notifications Container Styled Components
 *
 * @since 1.0.0
 */

import styled from "@emotion/styled";

/**
 * Notifications container styled component.
 *
 * @since 1.0.0
 */
export const NotificationsWrapper = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  display: flex;
  flex-direction: column-reverse;
  width: 350px;
  max-width: calc(100vw - 40px);
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
`;

/**
 * Animation wrapper for individual notifications.
 *
 * @since 1.0.0
 */
export const NotificationAnimationWrapper = styled.div<{
  $isVisible: boolean;
  $isExiting: boolean;
}>`
  transform: translateX(
    ${({ $isVisible, $isExiting }) =>
      $isVisible && !$isExiting ? "0" : "100%"}
  );
  opacity: ${({ $isVisible, $isExiting }) =>
    $isVisible && !$isExiting ? "1" : "0"};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  margin-bottom: 12px;

  /* Initial state for new notifications */
  ${({ $isVisible }) =>
    !$isVisible &&
    `
    transform: translateX(100%);
    opacity: 0;
  `}
`;
